import * as ACTION_TYPES from './Types';

const initialState = {
  requirements: {},
  views: {},
  message: '',
  error: null,
}

export const requirementReducer = (state = initialState, action) => {
  switch (action.type) {



    case ACTION_TYPES.GET_REQUIREMENT_SUCCESS:
      return {
        ...state,
        requirements: action.payload.data,
        message: action.payload.message,
      }
    case ACTION_TYPES.VIEW_REQUIRE_SUCCESS:
      return {
        ...state,
        views: action.payload.data,
        message: action.payload.message,
      }
    case ACTION_TYPES.GET_REQUIREMENT_ERROR:
    case ACTION_TYPES.VIEW_REQUIRE_ERROR:
      return {
        ...state,
        message: action.payload.message,
      }         

    default:
      return state;
  }
}
